import { useEffect } from "react";
import { X } from "lucide-react";

export const Modal = ({ testid, title, onClose, children, wide }) => {
  useEffect(() => {
    const k = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid={testid}>
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative w-full ${wide ? "max-w-lg" : "max-w-md"} max-h-[90vh] overflow-y-auto rounded-2xl border border-[#1F293D] bg-[#0F141F] p-6 shadow-2xl fade-up`}>
        <button data-testid={`${testid}-close`} onClick={onClose} className="absolute right-4 top-4 text-slate-500 hover:text-white"><X className="h-5 w-5" /></button>
        <h3 className="mb-4 pr-8 text-lg font-bold text-white">{title}</h3>
        {children}
      </div>
    </div>
  );
};

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-[11px] uppercase tracking-wider text-slate-500">{label}</span>
    <div className="mt-1">{children}</div>
  </label>
);

export const inputCls = "w-full px-3 py-2 rounded-lg bg-[#111827] border border-[#1F293D] text-sm text-slate-200 focus:border-sky-500 focus:outline-none";

export const Btn = ({ tone = "sky", className = "", ...p }) => {
  const tones = {
    sky: "bg-sky-500 text-white hover:bg-sky-600",
    ghost: "bg-[#1A2234] border border-[#202D45] text-slate-300 hover:text-white",
    emerald: "bg-emerald-500 text-slate-950 hover:bg-emerald-400",
  };
  return <button {...p} className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors disabled:opacity-40 ${tones[tone]} ${className}`} />;
};
